<template>
  <div>
    <!-- <v-btn @click="showUpload=!showUpload">Upload new image</v-btn>
    <v-card color="grey lighten-5" class="mt-4 mb-5 px-3 pb-3" v-if="showUpload">
      <v-flex xs12 sm12 md12><br>
        <h3 class="title mb-3">Upload images</h3>
        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
        <v-flex>
          <v-text-field class="ml-2"
            name="credit"
            label="Credit"
          ></v-text-field>
        </v-flex>
        <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn>
        <v-btn @click="dropzone.processQueue()">submit</v-btn>
        <v-btn @click="dropzone.processQueue()">clear</v-btn>
      </v-flex>
    </v-card> -->

    <!-- <v-container grid-list-md text-xs-center>  -->
    <v-layout row wrap mx-3>
      <!-- <div class="mt-0 pt-0 mb-3"> -->
      <v-flex
        style="background-color:#292929; color: #ddd;"
        class="mb-3 px-3 py-2 elevation-0 xs12"
      >
        <h3 class="font-weight-bold xs12 flex">
          Artwork Image
          <v-btn
            small
            round
            target="_blank"
            :href="
              `${$globals.fileserver}/upload_image.html?id=${artwork.id}&u=${c_user.id}`
            "
            color="black"
            text--color
            class="white--text right mt-0 mr-0 mb-0 px-3 xs12"
            rel="noopener noreferrer"
          >
            <v-icon small color="white" class="mr-2">cloud_upload</v-icon>
            Upload New
          </v-btn>
          <!-- <v-btn @click="showUpload=!showUpload">Upload new image</v-btn> -->
        </h3>
      </v-flex>
      <!-- <h3 class="mx-2 pb-0">Artwork Image</h3> -->
      <!-- <v-spacer></v-spacer>
      <v-flex xs12 class="px-0 mx-0">
        <v-divider class="mx-2 pb-0 mb-3 black"></v-divider>
      </v-flex> -->
      <v-flex xs12 class="px-0 mx-0 mb-5">
        <v-img
          v-if="artwork.top_photo_id"
          contain
          style="max-width: 100%; background-size: contain;"
          height="400"
          :src="
            `${$globals.oldserver}/data/artwork/${artwork.id}/${artwork.top_photo_id}_th_big.jpg`
          "
        />

        <!-- <v-img v-for="artwork_photo in artwork_photos" :key="artwork_photo.id" 
                  :src="`http://www.tb-cms.org/data/artwork/${artwork.id}/${artwork_photo.id}_new_th.jpg`" 
                  height=200 contain class="lighten-2"/> -->
      </v-flex>

      <!-- <h3 class="mx-2 pb-0">Conservation Images</h3>
      <v-spacer></v-spacer>
      <v-flex xs12 class="px-0 mx-0 mb-5">
        <v-divider class="mx-2 pb-0 mb-3 black"></v-divider>
      </v-flex>

      <h3 class="mx-2 pb-0">Installation Images</h3>
      <v-spacer></v-spacer>
      <v-flex xs12 class="px-0 mx-0 mb-5">
        <v-divider class="mx-2 pb-0 mb-3 black"></v-divider>
      </v-flex> -->

      <!-- <v-flex
        style="background-color:#292929; color: #ddd;"
        class="mb-3 px-3 py-2 elevation-0 xs12"
      >
        <h3 class="font-weight-bold body-2xs12 flex">Tags</h3>
      </v-flex>
      <v-card-text class="px-0" style="z-index: 0;">
        <v-chip
          label
          outline
          class="black black--text"
          @click="filter_photos('all')"
          key="all_key"
          >ALL</v-chip
        >
        <v-chip
          label
          outline
          class="black black--text"
          @click="filter_photos(k)"
          v-for="k in keywords_calc"
          :key="k"
        >
          {{ k }}
        </v-chip>
      </v-card-text> -->

      <!-- </div> -->
      <!-- <v-flex xs12>
        <v-card color="grey lighten-5"> -->
      <!-- <v-card-title style='color:black;'>Filter</v-card-title> -->
      <!-- <v-card-text style='color:black;'>
              <v-flex xs12 d-flex>
                <v-flex xs12 sm4 md4>
                  <v-checkbox v-model="filter" label="Artwork Images" value="ai" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-checkbox v-model="filter" label="Conservation Images" value="ci" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-checkbox v-model="filter" label="Installation Images" value="ii" hide-details></v-checkbox>
                </v-flex>
              </v-flex> -->

      <!-- <v-dialog v-model="dialog" xs10 max-width="900px">
            <v-card>
              <v-responsive v-if="image">
                <v-img
                  :src="
                    `http://www.tb-cms.org/data/artwork/${image.artwork_id}/${image.id}_new_th.jpg`
                  "
                  aspect-ratio="1"
                  class="grey lighten-2"
                ></v-img>
              </v-responsive>
              <v-card-title>
                <span class="headline">Image details</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>Filename: {{ image.fname }}</v-flex>
                    <v-flex xs12
                      >Keywords:
                      <v-chip v-for="k in image.keywords" :key="k">{{
                        k
                      }}</v-chip>
                    </v-flex>
                    <v-flex xs12>Credit: {{ image.credit }}</v-flex>
                    <v-flex
                      xs12
                      v-html="`Photographer: ${image.photographer_name}`"
                    ></v-flex>
                    <v-flex xs12 v-html="`artist: ${image.artist}`"></v-flex>
                    <v-flex
                      xs12
                      v-html="`image_descriptions: ${image.image_description}`"
                    ></v-flex>
                    <v-flex xs12>copyright: {{ image.copyright }}</v-flex>
                    <v-flex xs12>creator: {{ image.creator }}</v-flex>
                    <v-flex xs12>rights: {{ image.rights }}</v-flex>
                    <v-flex xs12>subject: {{ image.subject }}</v-flex>
                    <v-flex xs12
                      >copyright_notice: {{ image.copyright_notice }}</v-flex
                    >
                    <v-flex xs12
                      >copyright_flag: {{ image.copyright_flag }}</v-flex
                    >
                    <v-flex xs12
                      >Dimensions (W x H): {{ image.width }} x
                      {{ image.height }} pixels</v-flex
                    >
                  </v-layout>
                </v-container>
                <small></small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="" flat @click.native="dialog = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog> -->

      <!-- </v-card-text> -->
      <!-- <v-card-title style='color:black;'>Tags</v-card-title> -->
      <!-- </v-card>
      </v-flex> -->
      <!-- <v-flex xs12>
          <v-card>
            <v-card-text class="px-0">
              <v-container grid-list-xs fluid>
                <v-layout row wrap>
                  <v-flex v-for="artwork_photo in artwork_photos" :key="artwork_photo.id" xs4 md3 lg2 d-flex>
                    <v-card  class="d-flex">
                      <v-img :src="`http://www.tb-cms.org/data/artwork/${artwork.id}/${artwork_photo.id}_new_th.jpg`"
                        aspect-ratio="1" class="grey lighten-2"
                      > -->
      <!-- {{artwork_photo.keywords}} -->
      <!-- <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout> -->
      <!-- </v-img>
                      <v-card-actions>
                        <v-btn icon @click="show_photo(artwork_photo.id)" color="primary" dark><v-icon>info</v-icon></v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card> -->
      <!-- </v-flex> -->
    </v-layout>
    <!-- </v-layout> -->
    <!-- </v-container> -->

    <!-- <v-layout column class="mt-5">
        <v-layout d-flex align-start justify-start fill-height/>
          <v-card>
          </v-card>
      </v-layout> -->

    <!-- <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-container grid-list-sm fluid>
            <v-layout row wrap>
              <v-flex v-for="artwork_photo in artwork.artwork_photos" :key="artwork_photo.id" xs4 md3 lg2 d-flex>
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="`http://www.tb-cms.org/data/artwork/${artwork.id}/${artwork_photo.id}_new_th.jpg`"
                    aspect-ratio="1" class="grey lighten-2"
                  >
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex> -->

    <!-- </v-layout> -->

    <!-- <v-layout column>
    <v-container fluid grid-list-md class="grey lighten-4">
      <v-flex xs3>
        <v-card v-for="artwork_photo in artwork.artwork_photos" :key="artwork_photo.id">
          <v-card-media v-for="n in 10" :key="n"
            :src="`http://www.tb-cms.org/data/artwork/${artwork.id}/${artwork_photo.id}_new_th.jpg`"
            height="320px"
          >
          </v-card-media>
          <v-card-title primary-title>
            <div> -->
    <!-- <div class="headline"></div> -->
    <!-- <span class="grey--text">{{artwork_photo.photographer_name}} / {{artwork_photo.credits}}</span>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat>Download</v-btn>
            <v-btn flat color="purple">enlarge</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="show = !show">
              <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-slide-y-transition>
            <v-card-text v-show="show">
              <p>
              Filename: {{artwork_photo.fname}}</br>
              Dimensions: {{artwork_photo.width}} x  {{artwork_photo.height}}</br>
              Created: {{artwork_photo.created_at}}</br>
              Updated: {{artwork_photo.updated_at}}</p>
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-container>
    </v-layout> -->
    <!-- <v-layout>
      <v-flex xs12 sm12>
        <v-card> -->
    <!-- <v-card-actions>
            <v-select label="Size" :items="items" v-model="size"></v-select>
            <v-spacer></v-spacer>
          </v-card-actions> -->
    <!-- <v-container fluid grid-list-4>
            <v-layout row wrap>
              <v-flex xs2 v-for="artwork_photo in artwork.artwork_photos" :key="artwork_photo.id">
                <v-card flat tile>
                  <v-card-media
                    :src="`http://www.tb-cms.org/data/artwork/${artwork.id}/${artwork_photo.id}_new_th.jpg`"
                    height="150px"
                  >
                  </v-card-media>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout> -->
  </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  props: ['artwork'],
  data: () => ({
    // dialog: false,
    image: '',
    filter: [],
    keywords: [],
    artwork_photos: [],
    // showUpload: false,
    show: false
    // dropzoneOptions: {
    //   url: 'http://www.tb-cms.org/artworks/multi_uploaded_photo/132',
    //   thumbnailWidth: 150,
    //   maxFilesize: 2.5,
    //   headers: { "Header": "header value" },
    //   params: { "artwork": "artwork.id" },
    //   autoProcessQueue: false,
    //   id: 'dropzone',
    //   // thumbnailWidth: 120,
    //   // thumbnailHeight: 120,
    //   // headers: { "artwork": "artwork.id" },
    //   // previewTemplate: `
    //   //   <div class="dz-preview dz-file-preview">
    //   //     <div class="dz-details">
    //   //       <input type="text" />
    //   //       <div class="dz-filename"><span data-dz-name></span></div>
    //   //       <div class="dz-size" data-dz-size></div>
    //   //       <img data-dz-thumbnail />
    //   //     </div>
    //   //     <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
    //   //     <div class="dz-success-mark"><span>✔</span></div>
    //   //     <div class="dz-error-mark"><span>✘</span></div>
    //   //     <div class="dz-error-message"><span data-dz-errormessage></span></div>
    //   //   </div>`
    // }
  }),
  computed: {
    photos() {
      return this.artwork_photos
    },
    keywords_calc() {
      var artwork = this.artwork
      if (artwork && artwork.artwork_photos) {
        this.keywords = []
        for (var ap in artwork.artwork_photos) {
          if (artwork.artwork_photos[ap].keywords) {
            try {
              artwork.artwork_photos[ap].keywords = JSON.parse(
                artwork.artwork_photos[ap].keywords
              ).map(k => (k = k.toString()))
            } catch (err) {
              // console.log('error while parsing keywords')
            }
          } else {
            artwork.artwork_photos[ap].keywords = []
          }
          this.keywords = this.keywords.concat(
            artwork.artwork_photos[ap].keywords.map(k => (k = k.toString()))
          )
        }
      }
      if (artwork && this.keywords) {
        this.keywords = [...new Set(this.keywords)]
        this.keywords = this.keywords.sort(function(a, b) {
          return a.toUpperCase().localeCompare(b.toUpperCase())
        })
      }
      // console.log('artwork')
      // console.log(artwork)
      return this.keywords
    }
  },
  methods: {
    show_photo(id) {
      this.dialog = true
      this.image = this.artwork.artwork_photos.find(p => p.id === id)
    },
    filter_photos(tag) {
      // console.log(typeof(tag))
      this.artwork_photos = this.artwork.artwork_photos
      if (tag != 'all') {
        // console.log(this.photos)
        this.artwork_photos = this.photos.filter(
          p => p.keywords.indexOf(tag.toString()) != -1
        )
        // console.log(this.photos)
      }
    }
  },
  mounted() {
    this.filter_photos('all')
    // console.log('mounted')
    // console.log(this.artwork_photos)
    // this.artwork_photos = this.artwork.artwork_photos
    // this.artwork_photos = this.artwork.artwork_photos
  }
  // components: {vueDropzone: vue2Dropzone}
}
</script>

<style scoped>
.card {
  min-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/Images.vue